<template>
	<section>
		<section class="user-wrapper">
			<div class="user-item" v-for="item in list">
				<div class="role" v-if="item.certificationId !== -1 ">
					<el-image v-if="item.certificationId == 0 || item.certificationId == 1" :src="require('@/assets/crowd/personal.png')"></el-image>
					<el-image v-else-if="item.certificationId == 2 || item.certificationId == 3" :src="require('@/assets/crowd/company.png')"></el-image>
					<div class="text">{{item.certificationId == 0 || item.certificationId == 1?'个人':item.certificationId == 2 || item.certificationId == 3?'企业':'未认证'}}</div>
				</div>
				<div class="avatar">
					<el-image class="avatar-image" :src="item.avatar"></el-image>
					<el-image class="cert" v-if="item.certificationId == 0 || item.certificationId == 1" :src="require('@/assets/crowd/personal-v.png')"></el-image>
					<el-image class="cert" v-else-if="item.certificationId == 2 || item.certificationId == 3" :src="require('@/assets/crowd/company-v.png')"></el-image>
				</div>
				<div class="name" style="-webkit-box-orient: vertical;">{{item.nickname}}</div>
				<div class="desc" style="-webkit-box-orient: vertical;">{{item.summary}}</div>
				<!-- <div class="tag">标签：<span class="tag-item">软件开发</span><span class="tag-item">软件开发</span></div> -->
				<div class="btn">
					<el-button type="warning" round size="small" @click="toDetail(item.userId)">查看详情</el-button>
				</div>
			</div>
			
		</section>
		<el-pagination class="page"
			:hide-on-single-page="true"
			:page-size="9"
		    layout="prev, pager, next"
			@current-change="handleCurrentChange"
		    :total="total">
		  </el-pagination>
	</section>
</template>

<script>
import { getUserList } from '@/api/crowd/index'
export default {
    data() {
      return {
		page:1,
        list:[],
		total: 0
      };
    },
    methods: {
	  handleCurrentChange(val){
		this.page = val
	  	this.getDatalist()
	  },
	  async getDatalist(){
	  	const res = await getUserList({page:this.page,limit:9})
	  	if (res.code === 0) {
	  		this.list = res.data.list
	  		this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	  },
	  toDetail(id){
		  this.$router.push({name:'expert-detail',params:{id:id}})
	  }
    },
	mounted(){
		this.getDatalist()
	}
}
</script>

<style lang="scss" scoped>
.user-wrapper{
	display: flex;
	.user-item{
		flex: 0 0 32%;
		margin-right: 1%;
		background-color: #fff;
		box-shadow:  0 0 15px rgba(0,0,0,.05);
		padding: 20px;
		box-sizing: border-box;
		border-radius: 8px;
		position: relative;
		.role{
			width: 48px;
			height: 30px;
			position: absolute;
			left: 0;
			top: 20px;
			.text{
				color: #fff;
				font-size: 14px;
				position: absolute;
				left: 8px;
				top: 6px;
				z-index: 1;
			}
		}
		.avatar{
			position: relative;
			width: 80px;
			height: 80px;
			border-radius: 50%;
			margin: auto;
			border: 2px solid #fff;
			box-shadow: 0 0 10px rgba(0,0,0,.35);
			.avatar-image{
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
			.cert{
				width: 24px;
				height: 24px;
				position: absolute;
				right: 0;
				bottom: 0;
			}
		}
		.name{
			color: #333333;
			font-size: 18px;
			font-weight: 800;
			text-align: center;
			margin: 0;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			margin-top: 15px;
		}
		.desc{
			text-align: center;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			white-space: normal;
			min-height: 42px;
			color: #A7ABB4;
			font-size: 14px;
			margin-top: 8px;
		}
		.tag{
			font-size: 13px;
			margin-top: 8px;
			.tag-item{
				color: #A7ABB4;
				margin-right: 8px;
			}
		}
		.btn{
			text-align: center;
			margin: 20px 0 10px;
			.el-button--warning{
				background-color: #FF842E;
			}
		}
	}
}
</style>